import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Package, LogOut, Menu, X } from 'lucide-react';
import Button from '../ui/Button';
import { logout } from '../../utils/auth';

const Navbar = () => {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    window.location.href = '/';
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <>
      <motion.nav 
        className="nav-glassmorphic fixed top-0 left-0 right-0 z-50 h-16"
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.3, ease: 'easeOut' }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center justify-between">
          <div className="flex items-center space-x-8">
            <Link to="/dashboard" className="flex items-center space-x-2">
              <Package className="h-6 w-6 text-primary" />
              <span className="text-xl font-light text-foreground">AssetVault</span>
            </Link>
            
            <div className="hidden sm:flex items-center space-x-4">
              <Link to="/dashboard">
                <Button 
                  variant={isActive('/dashboard') ? 'default' : 'ghost'}
                  size="sm"
                >
                  Dashboard
                </Button>
              </Link>
              <Link to="/contractors">
                <Button 
                  variant={isActive('/contractors') ? 'default' : 'ghost'}
                  size="sm"
                >
                  Contractors
                </Button>
              </Link>
              <Link to="/admin">
                <Button 
                  variant={isActive('/admin') ? 'default' : 'ghost'}
                  size="sm"
                >
                  Admin
                </Button>
              </Link>
            </div>
          </div>

          <div className="flex items-center space-x-2">
            {/* Desktop logout button */}
            <Button 
              variant="ghost" 
              size="sm" 
              onClick={handleLogout}
              className="hidden sm:inline-flex items-center space-x-2"
            >
              <LogOut className="h-4 w-4" />
              <span>Logout</span>
            </Button>
            
            {/* Mobile menu button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="inline-flex sm:hidden items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none hover:bg-accent hover:text-accent-foreground h-9 px-3 rounded-md"
              aria-label="Toggle menu"
            >
              {mobileMenuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
            </button>
          </div>
        </div>
      </motion.nav>

      {/* Mobile menu */}
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.2 }}
            className="fixed top-16 left-0 right-0 z-40 nav-glassmorphic border-t border-border/50 sm:hidden"
          >
            <div className="px-4 py-4 space-y-2">
              <Link to="/dashboard" onClick={closeMobileMenu}>
                <Button 
                  variant={isActive('/dashboard') ? 'default' : 'ghost'}
                  size="sm"
                  className="w-full justify-start"
                >
                  Dashboard
                </Button>
              </Link>
              <Link to="/contractors" onClick={closeMobileMenu}>
                <Button 
                  variant={isActive('/contractors') ? 'default' : 'ghost'}
                  size="sm"
                  className="w-full justify-start"
                >
                  Contractors
                </Button>
              </Link>
              <Link to="/admin" onClick={closeMobileMenu}>
                <Button 
                  variant={isActive('/admin') ? 'default' : 'ghost'}
                  size="sm"
                  className="w-full justify-start"
                >
                  Admin
                </Button>
              </Link>
              <Button 
                variant="ghost" 
                size="sm" 
                onClick={() => {
                  handleLogout();
                  closeMobileMenu();
                }}
                className="w-full justify-start"
              >
                <LogOut className="h-4 w-4 mr-2" />
                Logout
              </Button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Navbar;

